import moment from 'moment'

import type { Days, MilliSeconds } from '~/shared/types/base/units'
/** 默认 */
const DEFAULT_DAYS_RANGE = 30 as Days // eslint-disable-line @typescript-eslint/no-magic-numbers

/**
 * 重设日期时间中的时分秒为 00:00:00
 * @param d 日期时间
 */
export function dayMaskDate(d: Date) {
  // make time to 00:00:00
  // which is the begin of a day
  d.setMilliseconds(0)
  d.setSeconds(0)
  d.setMinutes(0)
  d.setHours(0)
}

export type TTime = {
  /** 开始时间（ms） */
  startTime: MilliSeconds
  /** 结束时间（ms） */
  endTime: MilliSeconds
  /** 最后可用日期时间（ms） */
  lastAvailableDateTime: MilliSeconds
}

export type InitDateTimeRangeProps = {
  /** 时间范围，默认为 30 天 */
  daysRange?: Days
  /** 限定时间范围（天） */
  daysRangeLimit?: Days
  /** 是否排除今天 */
  excludeToday?: boolean
  /** 默认开始日期时间戳（ms） */
  startTime?: MilliSeconds
  /** 默认结束日期时间戳（ms） */
  endTime?: MilliSeconds
}

/**
 * 初始化时间范围
 */
export const initDateTimeRange = ({
  daysRange = DEFAULT_DAYS_RANGE,
  daysRangeLimit,
  excludeToday,
  startTime: st,
  endTime: et,
}: InitDateTimeRangeProps): TTime => {
  const d = new Date()
  dayMaskDate(d)

  const dateOfToday = d.getTime() as MilliSeconds
  const dateOfYesterday = moment(d).subtract(1, 'd').valueOf() as MilliSeconds

  let endDate
  if (et) {
    endDate = new Date(et)
    dayMaskDate(endDate)
  }

  let endTime = (endDate?.getTime() || dateOfToday) as MilliSeconds
  if (excludeToday && endTime >= dateOfToday) {
    endTime = dateOfYesterday
  } else if (endTime > dateOfToday) {
    // 默认结束日期支持从选项传入，需要排除非法日期
    endTime = dateOfToday
  }

  let startDate
  if (st) {
    startDate = new Date(st)
    dayMaskDate(startDate)
  }

  let limitedStartTime
  if (daysRangeLimit) {
    limitedStartTime = moment(endTime)
      .subtract(daysRangeLimit - 1, 'd')
      .valueOf()
  }

  const defaultStartTime = moment(endTime)
    .subtract(daysRange - 1, 'd')
    .valueOf() as MilliSeconds

  let startTime = (startDate?.getTime() || defaultStartTime) as MilliSeconds
  if ((limitedStartTime && startTime < limitedStartTime) || startTime > endTime) {
    // 默认开始日期支持从选项传入，需要排除非法日期
    startTime = defaultStartTime
  }

  return {
    lastAvailableDateTime: excludeToday ? dateOfYesterday : dateOfToday,
    startTime,
    endTime,
  }
}
